import * as BBApi from '.';

const rootUrl = BBApi.host + '/advertisements';

export const search = async (query: any) => {
	const url = new URL(rootUrl);

	if (query.search) url.searchParams.append('search', query.search);
	if (query.active) url.searchParams.append('active', query.active);
	if (query.region) url.searchParams.append('region', query.region);
	if (query.newYear) url.searchParams.append('newYear', query.newYear);
	if (query.advertiser) url.searchParams.append('advertiser', query.advertiser);

	const response = await BBApi.get(url.href);
	const advertisements = await response.json();
	return advertisements;
};

export const create = async (advertisement: any) => {
	const response = await BBApi.post(rootUrl, advertisement);
	const advertisementId = await response.text();
	return advertisementId;
};

export const get = async (advertisementId: number) => {
	const response = await BBApi.get(rootUrl + `/${advertisementId}`);
	const experience = await response.json();
	return experience;
};

export const update = async (advertisementId: number, experience: any) => {
	await BBApi.put(rootUrl + `/${advertisementId}`, experience);
};

export const remove = async (advertisementId: number) => {
	await BBApi.del(rootUrl + `/${advertisementId}`);
};

export const toggleActive = async (advertisementId: number, active: boolean) => {
	await BBApi.patch(rootUrl + `/${advertisementId}`, { active });
};

export const getAdvertisers = async () => {
	const response = await BBApi.get(rootUrl + '/advertisers');
	const advertisers = await response.json();
	return advertisers;
};
